import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useServices } from "@/app/use-services";
import { useSession } from "@/lib/auth/use-session";
import type { UserProfile } from "@/lib/api/models/chart";

export const PROFILE_QUERY_KEY = ["me", "profile"] as const;

/**
 * The signed-in person's profile. `data` is null when the account exists but
 * has no chart yet — a real state, not an error — and undefined while loading.
 */
export function useProfile() {
  const { api, session } = useServices();
  const snapshot = useSession(session);
  return useQuery<UserProfile | null>({
    queryKey: PROFILE_QUERY_KEY,
    queryFn: () => api.fetchMyProfile(),
    enabled: snapshot.status === "signed_in",
    staleTime: Infinity,
  });
}

export function useInvalidateProfile() {
  const client = useQueryClient();
  return () => client.invalidateQueries({ queryKey: PROFILE_QUERY_KEY });
}
